import React from 'react';
import { motion } from 'framer-motion';
import { publicMotion, publicUi } from '../../styles/publicDesignSystem';

const PublicFeatureCard = ({
  icon: Icon,
  title,
  description,
  tag,
  index = 0,
  className = '',
  iconContainerClass = 'bg-primary-100 text-primary-700'
}) => {
  return (
    <motion.article
      {...publicMotion.staggerChildren(index)}
      className={`${publicUi.cardInteractive} p-6 ${className}`}
    >
      <div className="flex items-start gap-4">
        {Icon ? (
          <div
            className={`inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${iconContainerClass}`}
            aria-hidden="true"
          >
            <Icon className="h-6 w-6" />
          </div>
        ) : null}
        <div className="min-w-0 flex-1">
          <div className="flex items-center justify-between gap-3">
            <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
            {tag ? (
              <span className="rounded-full bg-green-100 px-2.5 py-1 text-xs font-semibold text-green-800">
                {tag}
              </span>
            ) : null}
          </div>
          {description ? <p className="mt-2 text-sm leading-relaxed text-gray-600">{description}</p> : null}
        </div>
      </div>
    </motion.article>
  );
};

export default PublicFeatureCard;
